const state = {
  jobs: [],
  appliedJobs: [],
  markedJobs: [],
  totalRecords: 0,
  page: 1,
  pages: 0,
  showFilters: false
}
export default state
